import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonMap } from '../../../../../../_shared/components/common-map/common-map.component';
import { WorkshopMarkerFactory } from '../../../helpers/workshop-marker-factory.helper';
import { WorkshopMapInfoWindowBuilder } from '../../../helpers/workshop-map-info-window-builder.helper';
import { WorkshopClusterRenderer } from '../../../helpers/workshop-cluster-renderer.helper';
import { WorkshopLocationResponse } from '../../../models/workshop-response.model';
import { WorkshopType } from '../../../enums/maintenance-settings.enum';

@Component({
  selector: 'app-workshop-map',
  standalone: true,
  imports: [CommonModule, CommonMap],
  templateUrl: './workshop-map.component.html',
  styleUrl: './workshop-map.component.scss'
})
export class WorkshopMapComponent implements OnChanges {
  @Input() workshopLocations: WorkshopLocationResponse[] = [];
  @Input() isLoading = false;
  @Output() workshopMarkerClicked = new EventEmitter<number>();

  mapData: any[] = [];
  mapCenter: google.maps.LatLngLiteral = { lat: -28.5, lng: 25.5 };
  workshopTypeLabels: Record<WorkshopType, string> = {
    [WorkshopType.InHouse]: 'In-House',
    [WorkshopType.External]: 'External'
  };

  markerFactory = new WorkshopMarkerFactory();
  mapInfoWindowBuilder = new WorkshopMapInfoWindowBuilder();
  clusterRenderer = new WorkshopClusterRenderer();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['workshopLocations']) {
      this.mapData = this.workshopLocations.map(w => ({
        id: w.id,
        lat: w.latitude,
        lng: w.longitude,
        name: w.name,
        address: w.location,
        workshopType: this.workshopTypeLabels[w.workshopType],
        phoneNumber: w.phoneNumber,
        email: w.email
      }));
    }
  }

  onMarkerClicked(data: any): void {
    if (data?.id) {
      this.workshopMarkerClicked.emit(data.id);
    }
  }
}